<div class="dialogContainer450">
    <p class="headline5">{{'admin.domiciliacion.emisorDialogTitle' | translate}}</p>
    <form [formGroup]="form">

        <mat-radio-group 
            aria-labelledby="radioGroupRow" 
            class="radioEmisores" 
            formControlName="emisor"
            required>
                <mat-radio-button 
                    color="primary" 
                    class="radioEmisoresButton"
                    labelPosition="before"
                    *ngFor="let emisor of emisores" 
                    [value]="emisor">
                    <span class="subtitle2">{{emisor.nombre}}</span>
                </mat-radio-button>
        </mat-radio-group>

    </form>
    <br/>

    <button 
        [disabled]="!form.valid" 
        class="buttonFullWidth" 
        (click)="onSubmit()" 
        mat-raised-button color="primary">
        {{'admin.domiciliacion.emisorDialogButton' | translate}}
    </button>
</div>